var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"d-flex justify-center"},[_c('v-img',{attrs:{"src":require("@/assets/Obstetrika.png"),"max-width":_vm.$vuetify.breakpoint.xsOnly ? '75%' : '800px',"alt":"OBSTETRIKA"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }